:host {
    display: inline-flex;
}
